export const sendExperimentId = experimentId =>
  experimentId ? `|experiment_id: ${experimentId}` : "";
